import React from "react";
import { Link } from "react-router-dom";

const Footer = () => {
  const currentYear = new Date().getFullYear();

  return (
    <footer className="fixed bottom-0 left-0 right-0 z-40 bg-card border-t border-border py-3 px-4 lg:pl-64">
      <div className="max-w-7xl mx-auto">
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <img
              src="/assets/images/RocketOS_Brandmark_RGB.png"
              alt="Rocket"
              style={{ height: "20px", width: "auto", opacity: 0.7 }}
            />
            <p className="text-xs text-muted-foreground">
              © {currentYear} Rocket Tronc. All rights reserved.
            </p>
          </div>

          <nav className="hidden sm:flex items-center gap-4">
            <Link
              to="/help"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Help Centre
            </Link>
            <Link
              to="/privacy"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Privacy
            </Link>
            <Link
              to="/terms"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Terms
            </Link>
            <a
              href="mailto:support@rocket.new"
              className="text-xs text-muted-foreground hover:text-foreground transition-colors"
            >
              Support
            </a>
          </nav>
        </div>
      </div>
    </footer>
  );
};

export default Footer;
